/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { WalletStatus } from '../types/utils';

export type WalletID = string;

export class Wallet {
	encryptedPrivateKey: string = ''

	publicKey: string = ''

	status: WalletStatus = WalletStatus.ACTIVE

	constructor(obj?: any) {
		if (obj) {
			Object.assign(
				this,
				obj
			);
		}
	}
}